import type { CallbackResponse, ConfigResponse } from '../store/modules/merchant/types';

/** Whether the effective config value comes from a parent merchant (child context). */
export function isConfigInheritedForMerchant(
  merchantId: string,
  config?: Pick<ConfigResponse, 'merchantId' | 'isInherited' | 'configId'>,
): boolean {
  if (!config?.configId) {
    return true;
  }
  if (config.isInherited === false) {
    return false;
  }
  const cfgMerchantId = config.merchantId;
  return Boolean(cfgMerchantId) && (cfgMerchantId !== merchantId || Boolean(config.isInherited));
}

/** Child merchant has its own config row that overrides the parent value. */
export function isConfigOverriddenForMerchant(
  merchantId: string,
  partnerMerchantId: string | null | undefined,
  config?: Pick<ConfigResponse, 'merchantId' | 'isInherited' | 'configId'>,
): boolean {
  if (!partnerMerchantId || !config?.configId) {
    return false;
  }
  return !isConfigInheritedForMerchant(merchantId, config);
}

type CallbackInheritanceOptions = {
  /** When no callback row exists; default true (parent may supply via merge). */
  missingIsInherited?: boolean;
};

/** Whether an effective callback comes from a parent merchant (child context). */
export function isCallbackInheritedForMerchant(
  merchantId: string,
  callback?: Pick<CallbackResponse, 'merchantId' | 'isInherited' | 'callbackId'>,
  options?: CallbackInheritanceOptions,
): boolean {
  if (!callback?.callbackId) {
    return options?.missingIsInherited ?? true;
  }
  if (callback.isInherited === false) {
    return false;
  }
  const cbMerchantId = callback.merchantId;
  return Boolean(cbMerchantId) && (cbMerchantId !== merchantId || Boolean(callback.isInherited));
}
